/**
 * Super-Admin customer-portal impersonation session (sessionStorage).
 * Token is a short-lived HS256 JWT minted by admin-api.
 */

const STORAGE_KEY = "aixmed_portal_impersonation_token";

function b64urlJson(segment) {
  try {
    const pad = "=".repeat((4 - (segment.length % 4)) % 4);
    const b64 = (segment + pad).replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(b64));
  } catch {
    return null;
  }
}

export function decodeJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const parts = token.split(".");
  if (parts.length < 2) return null;
  return b64urlJson(parts[1]);
}

export function getImpersonationToken() {
  try {
    return sessionStorage.getItem(STORAGE_KEY) || "";
  } catch {
    return "";
  }
}

export function getImpersonationClaims() {
  const token = getImpersonationToken();
  if (!token) return null;
  const claims = decodeJwtPayload(token);
  if (!claims || !claims.impersonation) return null;
  const exp = Number(claims.exp || 0);
  if (!exp || exp * 1000 <= Date.now()) {
    clearImpersonationSession();
    return null;
  }
  return claims;
}

export function hasImpersonationSession() {
  return !!getImpersonationClaims();
}

export function setImpersonationToken(token) {
  const claims = decodeJwtPayload(token);
  if (!claims || !claims.impersonation) {
    throw new Error("Invalid impersonation token");
  }
  const exp = Number(claims.exp || 0);
  if (!exp || exp * 1000 <= Date.now()) {
    throw new Error("Impersonation token expired");
  }
  sessionStorage.setItem(STORAGE_KEY, token);
  return claims;
}

export function clearImpersonationSession() {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch {
    // ignore
  }
}

export async function getAuthorizationToken() {
  const imp = getImpersonationToken();
  if (imp && getImpersonationClaims()) {
    return imp;
  }
  return null;
}
